"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.customStyleFn = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _EditorUtils = _interopRequireDefault(require("../EditorUtils"));
var _SelectFontFamily = _interopRequireDefault(require("./SelectFontFamily"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
if (require('exenv').canUseDOM) require('./styles.scss');
class FontControls extends _react.Component {
  constructor(props) {
    super(props);
    this.state = _objectSpread({}, this.props.initialValue);
  }
  componentWillReceiveProps(nextProps) {
    const editorState = nextProps.editorState;
    const hasChangeInlineStyle = editorState.getCurrentInlineStyle() !== this.props.editorState.getCurrentInlineStyle();
    if (hasChangeInlineStyle) {
      const currentStyle = editorState.getCurrentInlineStyle();
      const initialValue = _objectSpread({}, this.props.initialValue);
      const fontSize = currentStyle.filter(value => value.startsWith('font-size')).last();
      if (fontSize) {
        initialValue.fontSize = fontSize.replace('font-size:', '').replace('px', '').replace(';', '').trim();
      }
      const fontFamily = currentStyle.filter(value => value.startsWith('font-family')).last();
      if (fontFamily) {
        initialValue.fontFamily = fontFamily.replace('font-family:', '').replace(';', '').trim();
      }
      if (initialValue) {
        this.setState(_objectSpread({}, initialValue));
      }
    }
  }
  handleChangeSize(e) {
    const _this$props = this.props,
      editorState = _this$props.editorState,
      setEditorState = _this$props.setEditorState;
    const fontSize = e.target.value;
    if (fontSize) {
      const editorStateWithFontSize = _EditorUtils.default.toggleInlineStyle(editorState, "font-size: ".concat(fontSize, "px;"));
      setEditorState(editorStateWithFontSize);
      this.setState({
        fontSize
      });
    }
  }
  handleChangeFont(e) {
    const _this$props2 = this.props,
      editorState = _this$props2.editorState,
      setEditorState = _this$props2.setEditorState;
    const fontFamily = e.target.value;
    const editorStateWithFontFamily = _EditorUtils.default.toggleInlineStyle(editorState, "font-family: ".concat(fontFamily, ";"));
    setEditorState(editorStateWithFontFamily);
    this.setState({
      fontFamily
    });
  }
  handleMouseOut() {
    this.props.focusEditor();
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "font-controls"
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "number",
      value: this.state.fontSize,
      onChange: this.handleChangeSize.bind(this),
      onMouseOut: this.handleMouseOut.bind(this),
      className: "font-controls-size input col col-3 h5 mx1"
    }), /*#__PURE__*/_react.default.createElement(_SelectFontFamily.default, {
      onChange: this.handleChangeFont.bind(this),
      value: this.state.fontFamily,
      onMouseOut: this.handleMouseOut.bind(this)
    }));
  }
}
exports.default = FontControls;
const customStyleFn = style => {
  const output = {};
  const fontSize = style.filter(value => value.startsWith('font-size')).last();
  if (fontSize) {
    output.fontSize = fontSize.replace('font-size:', '').replace(';', '').trim();
  }
  const fontFamily = style.filter(value => value.startsWith('font-family')).last();
  if (fontFamily) {
    output.fontFamily = fontFamily.replace('font-family:', '').replace(';', '').trim();
  }
  return output;
};
exports.customStyleFn = customStyleFn;